import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import { Avatar } from "@mui/material"; // Optional: use Avatar for consistent image rendering
import { BASE_IMAGE_URL } from "constants/apiConstants";
import IconButton from "@mui/material/IconButton";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";

export default function data(apiData = [], onEdit, onDelete) {
  return {
    columns: [
      { Header: "Name", accessor: "title", align: "left" },
      { Header: "Banner", accessor: "image", align: "center" },
      { Header: "Active", accessor: "isactive", align: "center" },
      { Header: "Action", accessor: "action", align: "center" },
    ],

    rows: apiData.map((item) => ({
      title: (
        <MDTypography variant="caption" color="text" fontWeight="medium">
          {item.title ?? "-"}
        </MDTypography>
      ),

      image: (
        <MDBox display="flex" justifyContent="center">
          {item.bannerImagePath ? (
            <Avatar
              src={
                item.bannerImagePath.startsWith("http")
                  ? item.bannerImagePath
                  : `${BASE_IMAGE_URL}${item.bannerImagePath}`
              }
              alt="Community"
              sx={{ width: 56, height: 56, borderRadius: 1 }}
            />
          ) : (
            <MDTypography variant="caption" color="text">
              No Image
            </MDTypography>
          )}
        </MDBox>
      ),

      isactive: (
        <MDBox display="flex" justifyContent="center">
          <MDTypography
            variant="caption"
            fontWeight="medium"
            color={item.active ? "success" : "error"}
          >
            {item.active ? "Yes" : "No"}
          </MDTypography>
        </MDBox>
      ),

      action: (
        // <MDTypography
        //   component="a"
        //   href="#"
        //   variant="caption"
        //   color="info"
        //   fontWeight="medium"
        //   onClick={(e) => {
        //     e.preventDefault();
        //     onEdit(item);
        //   }}
        // >
        //   Edit
        // </MDTypography>
        <MDBox display="flex" justifyContent="center" gap={1}>
          <IconButton
            size="small"
            color="primary"
            onClick={(e) => {
              e.preventDefault();
              onEdit(item);
            }}
          >
            <EditIcon fontSize="small" />
          </IconButton>
          <IconButton
            size="small"
            color="error"
            onClick={(e) => {
              e.preventDefault();
              onDelete(item);
            }}
          >
            <DeleteIcon fontSize="small" />
          </IconButton>
        </MDBox>
      ),
    })),
  };
}
